<template>
  <div>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="fornecedores"
        :loading="loading"
        :options.sync="options"
        :server-items-length="pageable.totalElements"
        hide-default-footer
        dense
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :search="search"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Fornecedores</v-toolbar-title>

            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisa por nome"
              single-line
              hide-details
              class="px-10"
            ></v-text-field>

            <v-btn color="primary" dark class="square" @click="abreForm"
              ><v-icon>{{ mdiPlus }}</v-icon></v-btn
            >
          </v-toolbar>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-icon color="#00A884" @click="contas(item)" title="Contas Pagar">{{
            mdiCalculatorVariantOutline
          }}</v-icon>
          <v-icon
            color="primary darken-2"
            @click="editar(item)"
            title="Editar"
            >{{ mdiPencilBox }}</v-icon
          >
          <v-icon
            color="error darken-2"
            @click="excluir(item)"
            title="Excluir"
            >{{ mdiCloseBox }}</v-icon
          >
        </template>
      </v-data-table>
      <div class="text-center pt-2">
        <v-pagination
          v-model="pageable.page"
          :length="pageable.totalPages"
          @input="changePage"
        ></v-pagination>
      </div>
    </v-card>
    <v-dialog
      v-model="dialog"
      transition="dialog-bottom-transition"
      persistent
      max-width="800px"
      :fullscreen="mobile"
    >
      <v-card>
        <v-card-title
          >Fornecedor
          <v-spacer></v-spacer>

          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <FornecedorForm
            v-if="dialog"
            @sucesso="inicializar"
            :payload="payload"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="contaDialog"
      transition="dialog-bottom-transition"
      persistent
      max-width="1200px"
      :fullscreen="mobile"
    >
      <v-card>
        <v-card-title
          >Pagamentos
          <v-spacer></v-spacer>

          <v-btn icon @click="contaDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <ContasFornecedor
            v-if="contaDialog"
            :fornecedorId="payload.fornecedorId"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { debounce } from "debounce";
import Fornecedor from "@/service/fornecedor";
import ContasFornecedor from "@/views/contas_pagar_fornecedor";
import FornecedorForm from "./Form";
import {
  mdiCloseBox,
  mdiPencilBox,
  mdiPlus,
  mdiCalculatorVariantOutline,
} from "@mdi/js";
export default {
  name: "Fornecedor",
  components: {
    FornecedorForm,
    ContasFornecedor,
  },
  data() {
    return {
      sortBy: "nome",
      sortDesc: false,
      search: "",
      mdiCloseBox,
      mdiPencilBox,
      mdiCalculatorVariantOutline,
      mdiPlus,
      loading: false,
      fornecedores: [],
      options: {},
      pageable: {},
      dialog: false,
      contaDialog: false,
      payload: {},
      headers: [
        {
          text: "Nome",
          value: "nome",
          align: "start",
          filterable: false,
          sortable: true,
        },
        {
          text: "Atividade",
          value: "atividade",
          filterable: false,
          sortable: true,
        },
        {
          text: "Telefone",
          value: "telefone",
          filterabldatae: false,
          sortable: true,
          width: 150,
        },
        {
          text: "Documento",
          value: "documento",
          filterabldatae: false,
          sortable: true,
        },
        {
          text: "Endereço",
          value: "endereco.enderecoStr",
          filterabldatae: false,
          sortable: false,
        },
        {
          text: "Ações",
          value: "actions",
          filterabldatae: false,
          sortable: false,
          width: 120,
        },
      ],
    };
  },

  computed: {
    mobile() {
      return this.$vuetify.breakpoint.mobile;
    },
  },
  watch: {
    sortBy(sort) {
      if (sort == undefined) return;
      this.inicializar({ page: 0, sort });
    },
    sortDesc(val) {
      if (val == undefined) return;
      const sort = val ? "desc" : "asc";
      this.inicializar({ page: 0, sort: this.sortBy + `,${sort}` });
    },
    search(nome, novoNome) {
      if (nome != novoNome && novoNome.trim().length > 0) this.pesquisa(nome);
    },
  },

  methods: {
    contas(item) {
      this.payload = { fornecedorId: item.id };
      this.$nextTick(() => (this.contaDialog = true));
    },
    pesquisa: debounce(async function (nome) {
      this.inicializar({ page: 0, nome });
    }, 700),
    changePage(value) {
      const sort = this.sortDesc ? ",desc" : ",asc";
      this.pageable.page = value;
      this.inicializar({ page: value - 1, sort: this.sortBy + `${sort}` });
    },
    abreForm() {
      this.payload = {};
      this.dialog = true;
    },
    async inicializar(options) {
      this.loading = true;
      this.dialog = false;

      const resp = await Fornecedor.findAll({ ...options });
      this.fornecedores = resp.content;
      this.pageable = {
        totalElements: resp.totalElements,
        totalPages: resp.totalPages,
        pageSize: resp.size,
        page: resp.number + 1,
      };
      this.loading = false;
    },
    editar(item) {
      this.payload = item;
      this.$nextTick(() => (this.dialog = true));
    },
    async excluir(item) {
      try {
        await Fornecedor.delete(item);
        this.$notify({
          title: "Sucesso",
          text: "Dados salvos!",
          type: "success",
        });
        await this.inicializar();
      } catch (error) {
        this.$notify({
          title: "Erro",
          text: "Ocorreu um erro ao excluir o Fornecedor, já está associado ao projeto",
          type: "error",
        });
        console.log(error);
      }
    },
  },
  created() {
    this.inicializar({ page: 0, sort: this.sortBy });
  },
};
</script>

<style>
</style>